import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import useUnauthorizedHandler from "../snippet/useUnauthorizedHandler";
import { debounce } from "../snippet/Debouncing";
import { GetAllClientList } from "../../actions/admin-provider/AllInviteContractorApi";
import { useSelector } from "react-redux";
import { logDOM } from "@testing-library/react";
import SelectAll from "./SelectAll";

function ClientMultiSelectDropdown({ title, updateFilter, client_org_idsC }) {
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [client_org_ids, setClient_org_ids] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();

  const visibleClientIds = (items || [])
    .map((item) => parseInt(item.organisation_id, 10))
    .filter(Boolean);

  const selectedVisibleCount = visibleClientIds.filter((id) =>
    client_org_ids.some((entry) => entry?.organisation_id === id)
  ).length;

  const allVisibleSelected =
    visibleClientIds.length > 0 && selectedVisibleCount === visibleClientIds.length;
  const someVisibleSelected =
    selectedVisibleCount > 0 && selectedVisibleCount < visibleClientIds.length;


  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSeachChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (item) => {
    setCheckData(true);
    const newEntry = {
      function_assignment_id: item.function_assignment_id,
      organisation_id: parseInt(item.organisation_id, 10),
    };

    const exists = client_org_ids.some(
      (entry) => entry.organisation_id === newEntry.organisation_id
    );

    if (exists) {
      
      setClient_org_ids(
        client_org_ids.filter(
          (entry) => entry.organisation_id !== newEntry.organisation_id
        )
      );
    } else {
      
      setClient_org_ids([...client_org_ids, newEntry]);
    }
  };

  const clearSelection = () => {
    setCheckData(true);
    
    setClient_org_ids([]);
  };

  const toggleSelectAll = () => {
    setCheckData(true);

    setClient_org_ids((prev) => {
      const prevMap = new Map(
        (prev || []).map((e) => [Number(e?.organisation_id), e])
      );

      const currentlyAllSelected =
        visibleClientIds.length > 0 && visibleClientIds.every((id) => prevMap.has(id));

      if (currentlyAllSelected) {
        visibleClientIds.forEach((id) => prevMap.delete(id));
      } else {
        (items || []).forEach((item) => {
          const id = parseInt(item.organisation_id, 10);
          if (!id) return;
          if (visibleClientIds.includes(id)) {
            prevMap.set(id, {
              function_assignment_id: item.function_assignment_id,
              organisation_id: id,
            });
          }
        });
      }

      return Array.from(prevMap.values());
    });
  };

  useEffect(() => {
    if (checkData) {
      updateFilter("client_org_ids", client_org_ids);
    }
  }, [client_org_ids]);

  const GenerateClientOverviewReport = useCallback(
    async (functionId) => {
      if (functionId) {
        const client_org_ids = [];
        dispatch(
          GetAllClientList({ function_id: functionId, search: searchTerm })
        ).then((response) => {
          if (response?.success === true) {
            const arrayData = response?.data;
            const allData = arrayData?.map((item) => ({
              trading_name: item.trading_name,
              organisation_id: item.organisation_id,
              function_assignment_id: item?.function_assignment_id,
            }))

            setItems(allData);
          
          if(client_org_idsC &&client_org_idsC.length){
            for (let i = 0; i < client_org_idsC.length; i++) {
              const filterClientIds =allData&& allData?.filter((ele) => ele.organisation_id == client_org_idsC[i]);
              // Send each filtered data to handleSelect
              
              if(filterClientIds){
                filterClientIds.forEach((filteredItem) => {
                  handleSelect(filteredItem);
                });
              }
            }
          }
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          } else {
            setLoadData(true);
          }
        });
      }
    },
    [dispatch, searchTerm]
  );

  useEffect(() => {
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "client"
      );
      GenerateClientOverviewReport(functionType[0]?.function_id);
    }
    
  }, [searchTerm, AllFunctions?.allFunction]);

  
  return (
    <div className="relative inline-block text-left w-34" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {client_org_ids?.length > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            { client_org_ids.length}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X client_org_ids' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">
              {client_org_ids.length} selected
            </span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>

          {/* Search input */}
          <div className="p-2">
            <input
              type="text"
              placeholder="Type here"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              // value={searchTerm}
              onChange={(e) => inputchangeSearch(e)}
            />
          </div>

          <SelectAll
            checked={allVisibleSelected}
            indeterminate={someVisibleSelected}
            disabled={visibleClientIds.length === 0}
            onChange={toggleSelectAll}
          />

          {/* Scrollable list of items */}
          <ul className="max-h-48 overflow-y-auto">
            {items?.map((item) => (
              <li
                key={item.organisation_id}
                className="flex items-center px-3 py-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  checked={client_org_ids?.some(
                    (filterItem) =>
                      filterItem.organisation_id ===
                      parseInt(item.organisation_id, 10)
                  )}
                  onChange={() => handleSelect(item)}
                />
                <span className="text-sm text-gray-700">
                  {item.trading_name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ClientMultiSelectDropdown;
